import { render, staticRenderFns } from "./MyInfoManage.vue?vue&type=template&id=498ef85d&scoped=true&"
import script from "./MyInfoManage.vue?vue&type=script&lang=ts&"
export * from "./MyInfoManage.vue?vue&type=script&lang=ts&"
import style0 from "./MyInfoManage.vue?vue&type=style&index=0&id=498ef85d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498ef85d",
  null
  
)

export default component.exports